import { get } from "@insite/client-framework/Services/ApiService";

export interface ExternalProviderLinkCollectionModel {
    externalProviders: ExternalProviderLinkModel[];
}

export interface ExternalProviderLinkModel {
    caption: string;
    url: string;
}

export function getExternalProviders() {
    return get<ExternalProviderLinkCollectionModel>(`/identity/poolcorpexternalproviders${window.location.search}`); // Poolcorp Custom Code Removed opti's returnUrl feature since our custom one handles PLP filters
}
